import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { useParams } from 'react-router-dom'
import Events from '../../api/Events';
import sSimg from '../../images/resource/ZMeghalaya.jpg';
import Subscribe2 from '../../components/Subscribe2/Subscribe2';
import Footer2 from '../../components/footer2/Footer2';
import VenueSection from '../../components/VenueSection/VenueSection';


const ZMeghalaya = (props) => {
    const { slug } = useParams()

    const eventDetails = Events[0];

    return (
        <Fragment>
            <Navbar hclass={'wpo-header-style-5'} topbarClass={'tb-block'} />
            <PageTitle pageTitle={eventDetails.eTitle} pagesub={'Event Details'} pageTitle2={'Event Details'}/>
            <section className="event-detail">
                <div className="auto-container">
                    <div className="inner-container">
                        <div className="event-detail_image">
                            <img src={sSimg} alt="" />
                        </div>
                        <div className="upper-box d-flex justify-content-between flex-wrap">
                            <h2 className="event-detail_title">{eventDetails.eTitle}</h2>
                            {/* <div className="event-detail_author">
                                <div className="event-detail_author-image">
                                    <img src={eventDetails.eImg} alt="" />
                                </div>
                                <div className="event-detail_author-name">{eventDetails.speaker}, <span>Art Critic</span></div>
                                <div className="event-detail_author-location"><span>Location:</span> Hall 1, Building, <br /> Golden Street , Southafrica</div>
                                <div className="event-detail_author-timing">08.00 am  09.00 am</div>
                                <div className="event-detail_author-icon flaticon-voice"></div>
                            </div> */}
                        </div>
                        <p>Zentara is a mindful retreat where clarity meets connection. It’s a pause from routine, crafted for thinkers, creators, and doers who seek meaning beyond meetings. Here, conversations flow over bonfires, ideas bloom in nature, and calm becomes the catalyst for growth. Step away from the rush and rediscover balance through shared experiences, wellness sessions, and purposeful circles. Zentara isn’t an escape, it’s a return to what truly matters. Step away. Come back stronger.</p>
                        <p>It is a curated corporate retreat designed to foster clarity, collaboration, and growth. Away from daily pressures, teams reconnect through shared experiences, strategic workshops, and mindful sessions that spark creativity. It’s where professionals pause, reflect, and return with renewed focus, energy, and perspective. </p>
                        <div className="middle-column">
                            <div className="row clearfix">
                                <div className="column col-lg-6 col-md-12 col-sm-12">
                                    <h3 className="event-detail_subtitle">Key Points of the Event</h3>
                                    <ul className="event-detail_list">
                                        <li>Evolve your mindset through shared experiences and mindful sessions.</li>
                                        <li>Engage in powerful conversations that spark real connection.</li>
                                        <li>Get featured in our community highlights and gratitude circle.</li>
                                        <li>Be part of a movement that values purpose, clarity, and growth.</li>
                                    </ul>
                                </div>
                                <div className="column col-lg-6 col-md-6 col-sm-12">
                                    <div className="event-detail_image-two">
                                        <img src="assets/images/resource/event-1.jpg" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p>It is a slow, soothing retreat designed to help you unwind, breathe, and simply be. Nestled in nature, it’s a space where the world quiets down and your mind follows. Gentle mornings, mindful sessions, and shared laughter create a rhythm that restores balance. Here, there are no deadlines, only conversations, reflection, and rest. You reconnect with yourself, with others, and with the calm you’ve been craving. Zentara is not an escape; it’s the art of slowing down and feeling alive again.</p>
                          <div className="appointmeny_button-box" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px', margin: '30px 0' }}>
                            <div style={{ flex: '0 0 auto' }}>
                                <a
                                    href="https://drive.google.com/file/d/1ThANCMimj6YaeXLWoTBL8ARuj0KdIYfU/view?usp=drive_link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="theme-btn btn-style-one"
                                >
                                    <span className="btn-wrap">
                                        <span className="text-one">Download Brochure</span>
                                        <span className="text-two">Download Brochure</span>
                                    </span>
                                </a>
                            </div>
                            <div style={{ flex: '0 0 auto', marginLeft: 'auto' }}>
                                <button
                                    type="button"
                                    className="theme-btn btn-style-one"
                                    disabled
                                    aria-disabled="true"
                                    style={{ cursor: 'not-allowed', opacity: 0.6 }}
                                >
                                    <span className="btn-wrap">
                                        <span className="text-one">Event Finished</span>
                                        <span className="text-two">Event Finished</span>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <VenueSection />
            {/* <Subscribe2 /> */}
            <Footer2/>
            <Scrollbar />
        </Fragment>
    )
};
export default ZMeghalaya;
